import {
    isSupported,
    onMessage,
    getToken,
} from "firebase/messaging";
import { messaging } from "../../../firebase";
import { addDevice, getNotifs } from "./PushNotificationSlice";
import { AppDispatch } from "../../../Redux/store";

const VAPID_KEY = "BG3kiqSMsMvjo_EVKV65TxylWB1YvCJTo-8yFLD4nLKWXHKY69GFLn2NUNsoP822i38eiROgCt5c1E5UHWLRLNM";

export const initWebNotifications = async (dispatch: AppDispatch) => {
    try {
        const supported = await isSupported();

        if (!supported) {
            console.log('Firebase Web Messaging is not supported');
            return;
        }

        if (Notification.permission !== 'granted') {
            const permission = await Notification.requestPermission();

            if (permission !== 'granted') {
                console.log("Notification permission not granted.");
                return;
            }
        }

        const registration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js"
        );

        await navigator.serviceWorker.ready;

        const fcmToken = await getToken(messaging,  {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: registration
        });

        if (fcmToken) {
            console.log("FCM Web Token:", fcmToken);
            
            await dispatch(addDevice(fcmToken)).unwrap();

        } else {
            console.log("No FCM token available.");
        }

        onMessage(messaging, async (payload) => {
            console.log("Foreground message received", payload);

            try {
                await dispatch(getNotifs()).unwrap();
            } catch (err) {
                console.error('Failed to urefresh notifications:', err);
            }
        });

    } catch (err) {
        console.error(
            "Error initializing web notifications:",
            err
        );
    }
}